import Layout from 'components/Layout'
import { GetStaticPaths } from 'next'
import dynamic from 'next/dynamic'
import { getPostPageProps } from 'props-getters/post'
import { logWarning } from 'shared-code/log'
import PageContainer from 'shared-components/service/PageContainer'
import { ExtractGetterProps } from 'shared-definitions/util-types'
import EventTemplate from 'templates/EventTemplate'
import PostTemplate from 'templates/PostTemplate'
import TextTemplate from 'templates/TextTemplate'
import { DSTplPage } from 'types.sg.ds'
import { DSLayoutProps } from 'shared-definitions/types'

const ReviewProductTemplate = dynamic(() => import('templates/ReviewProductTemplate'))
const BestListTemplate = dynamic(() => import('templates/BestListTemplate'))
const AboutNewTemplate = dynamic(() => import('shared-components/templates/AboutNewTemplate'))
const RootCategoryTemplateSG = dynamic(() => import('templates/RootCategoryTemplateSG'))
const TopicTemplateSG = dynamic(() => import('templates/TopicTemplateSG'))
const CategoryTemplate = dynamic(() => import('templates/CategoryTemplate'))
const DealsCategoryTemplateSG = dynamic(() => import('templates/DealsCategoryTemplateSG'))
const ContactsTemplate = dynamic(() => import('templates/ContactsTemplate'))
const SidedCategoryTemplate = dynamic(() => import('templates/SidedCategoryTemplate'))
const DiscoveryNewTemplateSG = dynamic(() => import('templates/DiscoveryNewTemplateSG'))

interface DSPageTplResult {
  tpl: React.ReactElement | null
  layoutProps: DSLayoutProps
}

function getPageTpl(page: DSTplPage): DSPageTplResult {
  switch (page.resource) {
    case 'about-new-page':
      return { tpl: <AboutNewTemplate page={page} />, layoutProps: {} }
    case 'category-page':
      return { tpl: <CategoryTemplate page={page} />, layoutProps: {} }
    case 'deals-category-page':
      return { tpl: <DealsCategoryTemplateSG page={page} />, layoutProps: {} }
    case 'sided-category-page':
      return { tpl: <SidedCategoryTemplate page={page} />, layoutProps: {} }
    case 'contact-page':
      return { tpl: <ContactsTemplate page={page} />, layoutProps: {} }
    case 'text-page':
      return { tpl: <TextTemplate page={page} />, layoutProps: {} }
    case 'post-page':
      return { tpl: <PostTemplate page={page} />, layoutProps: {} }
    case 'event-page':
      return { tpl: <EventTemplate page={page} />, layoutProps: {} }
    case 'review-product-page':
      return { tpl: <ReviewProductTemplate page={page} />, layoutProps: {} }
    case 'best-list-page':
      return { tpl: <BestListTemplate page={page} />, layoutProps: {} }
    case 'root-category-page':
      return { tpl: <RootCategoryTemplateSG page={page} />, layoutProps: {} }
    case 'topic-page':
      return { tpl: <TopicTemplateSG page={page} />, layoutProps: {} }
    case 'discovery-new-page':
      return { tpl: <DiscoveryNewTemplateSG page={page} />, layoutProps: {} }
    default:
      logWarning('Unknown tpl page', page)
      return { tpl: null, layoutProps: {} }
  }
}

const TplPage: React.VFC<ExtractGetterProps<typeof getPostPageProps>> = ({
  preview,
  page,
  common,
  ts,
}) => {
  const { tpl, layoutProps } = getPageTpl(page)
  return (
    <PageContainer
      layout={Layout}
      layoutProps={layoutProps}
      props={{
        tooltips: 'tooltips' in page ? page.tooltips : {},
        page,
        common,
        ts,
        preview,
      }}
    >
      {tpl}
    </PageContainer>
  )
}

// eslint-disable-next-line @typescript-eslint/require-await
export const getStaticPaths: GetStaticPaths = async () => ({
  paths: [],
  fallback: 'blocking',
})

export const getStaticProps = getPostPageProps()

export default TplPage
